import { useCallback } from 'react';
import { crashAdComponentEvent } from 'libs/common/event-tracker/events';
import ErrorBoundary from 'components/ErrorBoundary';
import useTracking from 'hooks/useTracking';
import { jsx as _jsx } from "react/jsx-runtime";

const AdErrorBoundary = _ref => {
  let {
    id,
    children,
    pageName,
    kind,
    dfpCode
  } = _ref;
  const {
    track
  } = useTracking();
  const handleErrorBoundary = useCallback(error => {
    track(crashAdComponentEvent({
      error: error ? error.toString() : '',
      placementId: id,
      pageName,
      kind,
      dfpCode
    }));
  }, [id, dfpCode, pageName, kind, track]);
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    onError: handleErrorBoundary,
    children: children
  });
};

export default AdErrorBoundary;